import script from "./NavCard.vue?vue&type=script&setup=true&lang=js"
export * from "./NavCard.vue?vue&type=script&setup=true&lang=js"

import "./NavCard.vue?vue&type=style&index=0&id=82aacd8c&lang=scss&scoped=true"

import exportComponent from "/Users/pontiroli/Desktop/Repositories/eni/dist/eni-dist-eni-for-2022-hub-e-longform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-82aacd8c"]])

export default __exports__